/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type SettingsPageMemberManagementViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageMemberManagementViewQuery = { staffsByPlanner: Array<{ guid: string, email: string, role: Types.StaffRole, name: string | null, connectedThirdPartyProvider: Types.OAuthProvider | null }> };


export const SettingsPageMemberManagementViewDocument = gql`
    query SettingsPageMemberManagementView {
  staffsByPlanner {
    guid
    email
    role
    name
    connectedThirdPartyProvider
  }
}
    `;

/**
 * __useSettingsPageMemberManagementViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageMemberManagementViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageMemberManagementViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageMemberManagementViewQuery();
 */
export function useSettingsPageMemberManagementViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>(SettingsPageMemberManagementViewDocument, {}, options);
}
export function useSettingsPageMemberManagementViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>(SettingsPageMemberManagementViewDocument, {}, options);
}
export type SettingsPageMemberManagementViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageMemberManagementViewQuery, SettingsPageMemberManagementViewQueryVariables>;